<template>
  <div>
    <v-data-table
      :search="search"
      :headers="headers"
      :items="data"
      item-key="Created"
      class="elevation-1"
      no-data-text="Not trades"
    >
      <template v-slot:top>
        <v-toolbar class="pt-2 px-4" flat color="#2d3540">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            name="searchTrade"
            color="#4dbac0"
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:item.createdAt="{ item }">{{item.createdAt | timator}}</template>


      <template v-slot:item.MaxOpenQuantity="{ item }">{{item.MaxOpenQuantity}}</template>

      <template v-slot:item.FlatToFlatMaximumOpenPositionProfit="{ item }">
        <div>
          <div class="float-right">
            <div class="roboto-condensed profit">
              {{item.FlatToFlatMaximumOpenPositionProfit.toFixed(2)}}
              <!-- <v-icon color="#79C04D" size="15">trending_up</v-icon> -->
            </div>
            <div class="roboto-condensed loss">
              {{item.FlatToFlatMaximumOpenPositionLoss.toFixed(2)}}
              <!-- <v-icon color="#E62163" size="15">trending_down</v-icon> -->
            </div>
          </div>
        </div>
      </template>

      <template v-slot:item.rrr="{ item }">
        <div>
          <div
            class="float-right roboto-condensed pt-1"
            style="font-size: 20px"
            :class=" Math.abs(item.FlatToFlatMaximumOpenPositionProfit / item.FlatToFlatMaximumOpenPositionLoss) >= 0.8 ? 'profit' : 'loss' "
          >{{ item.FlatToFlatMaximumOpenPositionProfit | rrr(item.FlatToFlatMaximumOpenPositionLoss) }}</div>
        </div>
      </template>

      

      <template v-slot:item.eff="{ item }">
        <div>
          <div
            class="float-right roboto-condensed pt-1"
            style="font-size: 20px"
            :class=" item.ClosedProfitLoss <= 0 ? 'loss' : 'profit' "
          >
            {{ item.FlatToFlatMaximumOpenPositionProfit | eff(item.ClosedProfitLoss,item.FlatToFlatMaximumOpenPositionLoss) }}
            <!-- <span style="font-size:16px">%</span> -->
          </div>
        </div>
      </template>

      <template v-slot:item.nevim="{ item }">
        <div v-if="item._prepare">
          <v-chip
            v-for="chip in item._prepare.checklist"
            :key="chip.name"
            x-small
            :disabled="!chip.selected"
            color="#4dbac0"
            class="float-left mr-1"
          ><span style="font-size: 10px">{{chip.name}}</span></v-chip>
        </div>
      </template>

      <template v-slot:item.ClosedProfitLoss="{ item }">
        <v-btn
          x-small
          class="roboto-condensed"
          style="font-size: 12px"
          :color="item.ClosedProfitLoss > 0 ? '#79C04D': (item.ClosedProfitLoss < 0 ?'#E62163' : '#808F9C')"
        >${{item.ClosedProfitLoss.toFixed(2)}}</v-btn>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-btn @click="routeTrade(item.openTimestamp)" text icon color="white">
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>


<script>
var moment = require("moment-timezone");
import { mapGetters } from "vuex";
export default {
  props: { data: Array },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Created",
          value: "createdAt",
          sortable: true,
          align: "center"
        },
        { text: "Ticker", value: "Symbol.global", align: "right" },
        { text: "PL", value: "ClosedProfitLoss", align: "center" },
        {
          text: "RU&DD",
          value: "FlatToFlatMaximumOpenPositionProfit",
          align: "right",
          sortable: false
        },
        { text: "RU/DD", value: "rrr", align: "right", sortable: false },
        { text: "Eff.%", value: "eff", align: "right", sortable: false },
        { text: "Max Qty", value: "MaxOpenQuantity", align: "center" },
        { text: "Checklist", value: "nevim", align: "right", sortable: false },
        { text: "", value: "action", sortable: false, align: "right" }
      ]
    };
  },
  computed: {
    ...mapGetters(["username", "timezone"])
  },
  filters: {
    rrr: function(value1, value2) {
      var result = Math.abs(value1 / value2).toFixed(2);
      return result;
    },
    eff: function(value1, value2, value3) {
      if (value2 <= 0) return Math.abs((value2 / value3) * 100).toFixed(1);
      return Math.abs((value2 / value1) * 100).toFixed(1);
    },
    timator: function(value) {
      return moment(value).format("L HH:MM"); //moment.tz(new Date(), this.timezone)//.format('L HH:MM')
    }
  },
  methods: {
    routeTrade(id) {
      return this.$router.push({
        name: "Trade",
        params: { name: this.$route.params.name, id: id }
      });
    }
  }
};
</script>

<style>
</style>